import * as React from 'react';
import { fetchWorkflowWebhookQuery } from 'api/queries';
import { useGraphql } from 'utils/hooks/useGraphql';
import { WorkflowWebhookDetails } from './WorkflowWebhookDetails';
import { WorkflowWebhookHeader } from './WorkflowWebhookHeader';
import type { WorkflowWebhook } from '../types';
import { transformWorkflowWebhook } from '../utils';

const EMPTY_WEBHOOK = {
  name: ' Webhook',
  endpoint: '',
  destination: '',
  method: '',
  contentType: '',
  authType: '',
  clientId: '',
  clientSecret: '',
  tokenEndpoint: '',
  headers: [],
  body: [],
  jsBody: '',
  formBody: [],
  basicAuthToken: '',
  includeDefaultFields: true,
  userFields: [],
};

type Props = {
  match: any;
};

export const WorkflowWebhookPage = ({ match }: Props) => {
  const [webhook, setWebhook] = React.useState<WorkflowWebhook>(EMPTY_WEBHOOK);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { refetch } = useGraphql(fetchWorkflowWebhookQuery, {
    variables: { id: Number(match.params.id) },
    onCompleted: ({ workflowWebhook = {} }) => {
      setWebhook(transformWorkflowWebhook(workflowWebhook));
    },
  });

  const reload = async () => {
    const {
      data: { workflowWebhook },
    } = await refetch();
    setWebhook(transformWorkflowWebhook(workflowWebhook));
  };

  const onSave = () => {
    reload();
  };

  const onCancel = async () => {
    reload();
  };

  return (
    <div>
      <WorkflowWebhookHeader workflowWebhook={webhook} title={webhook ? webhook.name : '...'} />
      <WorkflowWebhookDetails
        webhook={webhook}
        onUpdate={setWebhook}
        onSave={onSave}
        onCancel={onCancel}
      />
    </div>
  );
};
